import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

const isMobile = isMobileDevice();

export const FilterWrapperMain = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 390px;
    height: ${({bannerHeight}) =>
        bannerHeight ? `calc(78vh - ${bannerHeight})` : '78vh'};
    align-self: center;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    overflow: hidden;
    z-index: 3000;
    ${media.mediumDevice`
        width: 360px;
    `}
    ${media.mobileDevice`
		height: 100vh;
		width: 100vw;
		max-width: none;
    `}
    @media screen and (orientation: landscape) and (max-width: 1024px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(80vh - ${bannerHeight})` : '80vh'};
    }
    @media screen and (orientation: landscape) {
        ${isMobile &&
        css`
            height: 65vh;
        `}
    }
    @media only screen and (min-device-width: 370px) and (max-device-width: 950px) and (orientation: landscape) {
        height: 63vh;
    }
`;

export const FilterContentMain = styled.div`
    display: flex;
    flex-direction: column;
    background: #f5f5f5 !important;
    flex-grow: 1;
    height: 100vh;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar {
        display: block;
        width: 7px;
    }

    &::-webkit-scrollbar-thumb {
        background: #afafaf;
        border-radius: 10px;
        height: 7rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #afafaf;
    }
    ${media.mobileDevice`
       margin-top:-10px !important;
    `}
`;

export const FilterHeading = styled.p`
    color: #140f4b;
    display: ${({ display }) => (display ? display : 'inline-block')};
    font-size: 24px !important;
    line-height: 39px;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    padding-top: ${(props) => (props.filterAdmin ? '10px' : '0px')};

    letter-spacing: 0;
    margin: 0 0 -9px 7px;
    border-bottom: ${({ selected }) =>
        selected ? '4px solid #1010EB' : 'none'};
    &:hover {
        cursor: pointer;
    }
    ${media.smalDevice`
    padding-left: 2px;
    `}
    ${media.mobileDevice`
        font-size: 18px;
        line-height: 31px;
        color: #000000;
    `}
`;

export const Reset = styled.p`
    color: ${({ isView }) => (isView ? '#1010eb' : '#A8A8A8')};
    font-size: 15px;
    font-family: AvenirNextWorld Demi;

    margin: 0 20px -7px 0;
    line-height: 27px;
    align-self: center;
    &:hover {
        cursor: pointer;
    }
    ${media.smalDevice`
    margin-right: 20px;
`}
`;

export const FilterHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 11px 16px 13px 16px;
    ${media.mobileDevice`
    margin-bottom: 35px;
`}
`;
export const FilterFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding-right: 14px;
    padding-left: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background: #ffffff;
    position: static;
    bottom: 0px;
    box-sizing: border-box;
    width: 100%;
    height: 10%;
`;

export const FooterCloseButton = styled.button`
    height: 38px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    border: 1px solid #1010eb;
    background: #ffff;
    align-content: center;
    width: 40%;
    &:hover {
        cursor: pointer;
    }
`;

export const FooterApplyButton = styled.button`
    height: 38px;
    background: ${(props) => (props.applyButton ? '#1010EB' : '#3c3c3c')};
    border-radius: 5px;
    display: flex;
    justify-content: center;
    width: 40%;
    opacity: 1;
    border: none;
    &:hover {
        cursor: pointer;
    }
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: ${(props) => props.color};
    font-size: 15px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;

export const FilterBlock = styled.div`
    top: 5rem;
    right: 2rem;
    ${media.smalDevice`
		top: 0;
		left: 0;
		margin-top:0;
        right:0;
	`}
    z-index: 200;
    background: #f5f5f5;
    opacity: 1;
`;

export const FooterWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-evenly;
`;
export const EmptyBox = styled.div`
    margin: 0.8rem 0 3.6rem 0;
    ${media.smalDevice`
        margin-bottom: 3.6rem;
    `}
`;

export const FilterHeaderContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: -14px;
    ${media.mobileDevice`
    margin-top: -11px !important;
`}
`;
